import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import {ActionMeta, SingleValue} from 'react-select';
import {InvoiceOrderDocument, Option} from '../../../../common/types';
import InputTypeAhead from '../../../../common/components/ui/InputTypeAhead';
import search from '../../../../common/assets/icons/search.svg';
import styles from './InputInvoice.module.scss';

type InputInvoiceProps = {
  loadInvoiceOptions: (input: string) => Promise<Option[]>
  onInvoiceChanged: (input: string) => Promise<void>
  updateForm: () => void
  invoiceOrder: InvoiceOrderDocument | null
};

const InputInvoice = ({
                        loadInvoiceOptions,
                        onInvoiceChanged,
                        updateForm,
                        invoiceOrder
}: InputInvoiceProps) => {
  const intl = useIntl();
  const label = intl.formatMessage({
    id: 'payment-form-invoice', defaultMessage: 'Invoice'
  });
  const placeholder = intl.formatMessage({
    id: 'common-select-label', defaultMessage: 'Select'
  });
  const [field, meta, helper] = useField({name: 'invoiceID'});
  const [/*fieldCustomerID*/, /*metaCustomerID*/, helperCustomerID] = useField({name: 'customerID'});
  const [fieldCustomerLink, /*metaCustomerLink*/, helperCustomerLink] = useField({name: 'customerLink'});

  const handleChange = (invoiceOption: SingleValue<Option>, actionMeta: ActionMeta<Option>) => {
    helper.setValue(invoiceOption?.value || '');
    helperCustomerLink.setValue('');
    if (actionMeta.action === 'clear') {
      Boolean(invoiceOrder?.customerID)
        ? updateForm()
        : helperCustomerID.setValue('')
    }
    if (invoiceOption?.value && invoiceOption?.value !== field.value) {
      onInvoiceChanged(invoiceOption.value).catch(console.error);
    }
  };

  const inputValue = field?.value
    ? {label: field.value, value: field.value}
    : {label: '', value: ''};

  return (
    <div className={styles.selectContainer}>
      <InputTypeAhead
        <Option, false>
        {...field}
        {...meta}
        id={field.name}
        value={inputValue}
        label={label}
        placeholder={placeholder}
        loadOptions={loadInvoiceOptions}
        onChange={handleChange}
        customClassnames={{
          control: styles.control,
          label: styles.label
        }}
        isDisabled={Boolean(fieldCustomerLink.value)}
      />
      <img
        src={search}
        alt="search"
        className={styles.searchIcon}
      />
    </div>
  );
};

export default InputInvoice;
